import React, { createContext, useContext, useState, useCallback } from "react";

interface SubscriptionContextType {
  showGracePeriodModal: boolean;
  triggerGracePeriodModal: () => void;
  closeGracePeriodModal: () => void;
}

const ExpiryContext = createContext<SubscriptionContextType | null>(null);

export const ExpiryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showGracePeriodModal, setShowGracePeriodModal] = useState(false);

  const triggerGracePeriodModal = useCallback(() => setShowGracePeriodModal(true), []);
  const closeGracePeriodModal = useCallback(() => setShowGracePeriodModal(false), []);

  return (
    <ExpiryContext.Provider value={{ showGracePeriodModal, triggerGracePeriodModal, closeGracePeriodModal }}>
      {children}
    </ExpiryContext.Provider>
  );
};

export const useExpiryContext = () => {
  const ctx = useContext(ExpiryContext);
  if (!ctx) {
    return {
      showGracePeriodModal: false,
      triggerGracePeriodModal: () => { },
      closeGracePeriodModal: () => { },
    };
  }
  return ctx;
};